import {makeStyles} from "@material-ui/core";

export default function Styles() {
    return makeStyles(theme => ({
        chip: {
            margin: 2
        }
    }));
};
